import type { PromoLabel } from './types';

// First label in authored order listing any campaign the product is in, or null.
// Authored row order is the whole precedence rule.
export const matchPromoLabel = (
  productCampaignIds: string[],
  promoLabels: PromoLabel[],
): PromoLabel | null => {
  const productIds = new Set(productCampaignIds);

  return (
    promoLabels.find((promoLabel) => promoLabel.campaignIds.some((id) => productIds.has(id))) ??
    null
  );
};
